// extracted by mini-css-extract-plugin
export var button = "_6r-4";
export var hasDarkBackground = "_6r-7";
export var hasLightBackground = "_6r-6";
export var iconWrapper = "_6r-0";
export var large = "_6r-2";
export var medium = "_6r-1";
export var small = "_6r-5";
export var xsmall = "_6r-3";